import React, { useMemo } from 'react';
import { __, sprintf } from '@wordpress/i18n';

// store
import { useStoreValue } from '../../../../../../store';

// components
import StatusIconComponent from '../../../../../../components/StatusIconComponent';
import { head } from 'ramda';
import { useParams } from 'react-router-dom';

const ProjectTopBar = () => {
    const { projectId } = useParams();
    const projects = useStoreValue('projects');
    const projectTitle = useMemo(() => {
        const project = head(projects.filter(o => o.id === projectId))
        return project ? project.title : '';
    }, [projects, projectId]);

    return(
        <div className="userStatusTopBar">
            <StatusIconComponent status="in_progress"/>
            <span className="userStatusTopBar__text">
                {sprintf(__('Progetto: %s', 'soundbetween'), projectTitle)}
            </span>
        </div>
    )
}

export default ProjectTopBar;